module.exports = __webpack_public_path__ + "static/customer-experience-776bb23c73ae6d73a46a982f0f23dd43.png";